import { makeStyles } from '@material-ui/core/styles'

export const styles = {
  card: 'w-full h-full p-4',
}

const useStyles = makeStyles(theme => ({
  tab: {
    borderColor: `${theme.palette.primary.main} !important`,
  },
}))

export { useStyles }
